import React, { useState, useEffect, useContext, useCallback, Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import AuthContext from "../../../../context/auth-context";
import { setAllowChanges } from "../../utils/utils";
import axios from "axios";

const theme = createMuiTheme({
  overrides: {
    MuiInputBase: {
      root: {
        fontFamily: "Open Sans",
        fontSize: "14px",
        lineHeight: "19px",
      },
    },
  },
  palette: {
    primary: {
      main: "#0b1f82",
    },
  },
});

function Messages(props) {
  const roles = useContext(AuthContext).user_data.roles;
  const allowChanges = setAllowChanges(
    props.rental_agreement.fraud_status,
    roles
  );

  const rental_agreement_key = props.rental_agreement.rental_agreement_key;
  const [isFetchingMessages, setIsFetchingMessages] = useState(false);
  const [retrievedMessages, setRetrievedMessages] = useState("");
  const [currentMessage, setCurrentMessage] = useState("");
  const [disableChange, setDisableChange] = useState(false);
  const [difference, setDifference] = useState(null);
  const [isFocused, setIsFocused] = useState(true);
  const [hasFetchedForTheFirstTime, setHasFetchedForTheFirstTime] =
    useState(false);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsFocused(document.visibilityState === "visible");
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  function handleLoadMessages(messages) {
    const messages_text = messages.data.map((message) => {
      return (
        moment(message.created_at).format("HH:mm:ss") +
        " - " +
        message.analyst_name +
        ": " +
        message.message
      );
    });
    const retrieved_messages = messages_text.join("\n");
    setRetrievedMessages(retrieved_messages);
  }

  useEffect(() => {
    if (allowChanges) {
      const timer = setTimeout(() => {
        const now = moment();
        const limit = moment(props.rental_agreement.manual_analysis_limit_date);
        const diff = limit.diff(now, "seconds");
        setDifference(diff);
      }, 500);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [allowChanges, props.rental_agreement.manual_analysis_limit_date]);

  const messageRetrieve = useCallback(() => {
    if (allowChanges && !disableChange && !isFetchingMessages) {
      setIsFetchingMessages(true);
      axios
        .get(
          "/dash/car_rental/rental_agreement/" +
            rental_agreement_key +
            "/messages"
        )
        .then((response) => {
          handleLoadMessages(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setIsFetchingMessages(false);
        });
    }
  }, [allowChanges, disableChange, rental_agreement_key, isFetchingMessages]);

  useEffect(() => {
    if (!hasFetchedForTheFirstTime) {
      messageRetrieve();
      setHasFetchedForTheFirstTime(true);
    }
  }, [hasFetchedForTheFirstTime, messageRetrieve]);

  useEffect(() => {
    const messageIntervalId = setInterval(() => {
      if (!isFetchingMessages && isFocused) {
        messageRetrieve();
      }
    }, 5000);

    return () => {
      clearInterval(messageIntervalId);
    };
  }, [isFetchingMessages, messageRetrieve, isFocused]);

  useEffect(() => {
    if (difference === null) return;
    else if (difference < 0) setDisableChange(true);
    else {
      const timer = setTimeout(
        () => setDisableChange(true),
        Math.min(difference * 1000, 1000 * 60 * 60 * 24)
      ); // Max. Cap: 1 day
      return () => clearTimeout(timer);
    }
  }, [difference]);

  const handleCurrentMessageChange = (event) => {
    if (event.target.value.length === 0) setCurrentMessage(null);
    else setCurrentMessage(event.target.value);
  };

  const submitMessage = () => {
    const payload = {
      message: currentMessage,
      visible_to_store: true,
    };
    axios
      .post(
        "/dash/car_rental/rental_agreement/" +
          rental_agreement_key +
          "/message",
        payload
      )
      .then((response) => {
        setCurrentMessage("");
        axios
          .get(
            "/dash/car_rental/rental_agreement/" +
              rental_agreement_key +
              "/messages"
          )
          .then((response) => {
            handleLoadMessages(response);
          })
          .catch((error) => {
            console.error(error);
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleMessageKeypress = (e) => {
    if (e.key === "Enter") {
      submitMessage();
    }
  };

  const handleSubmitMessage = (event) => {
    submitMessage();
  };

  return (
    <div className="analysisCard">
      <div className={["blueText", "subtitleSize"].join(" ")}>Mensagens</div>
      <ThemeProvider theme={theme}>
        <TextField
          fullWidth
          multiline
          color="primary"
          variant="outlined"
          margin="dense"
          rows="5"
          disabled={true}
          onChange={handleCurrentMessageChange}
          defaultValue={retrievedMessages}
        />
      </ThemeProvider>
      {allowChanges && !disableChange ? (
        <div>
            <div style={{ display: "flex" }}>
              <ThemeProvider theme={theme}>
                <TextField
                  fullWidth
                  color="primary"
                  variant="outlined"
                  margin="dense"
                  rows="1"
                  disabled={!(allowChanges && !disableChange)}
                  onChange={handleCurrentMessageChange}
                  value={currentMessage}
                  onKeyPress={handleMessageKeypress}
                />
              </ThemeProvider>
              <div
                className={[
                  "button",
                  "approved",
                  "normalText",
                  "normalMediumSize",
                ].join(" ")}
                style={{
                  color: "#141414",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                onClick={handleSubmitMessage}
              >
                ENVIAR
              </div>
            </div>
          </div>
      ) : null}
    </div>
  );
}

export default Messages;
